console.log('custom.js');
if (window.location.href.indexOf("prospect%2Cnewsletter&form_type=customer") > -1 && document.querySelector('.email-exist-message')) {
  document.querySelector('.email-exist-message').classList.remove('hidden');
}
/*-- For Cookie Consent Pop Up Glitch --*/
setInterval(function(){
 $(document).find(".cc-window.cc-floating:not(.cc-invisible)").length
 ? $("body").addClass("cookie-consent") 
 : $("body").removeClass("cookie-consent");
},500);


function swatchSelector(event){
  //   console.log(event.target);
  let BtnElement = event.target;
  $(event.target).parents(".swatches-wrapper").find(".swatch-active").removeClass("swatch-active");
  $(event.target).addClass("swatch-active");
  let swatchColorName = $(event.target).attr("data-swatch-name");
  $(event.target).parents(".collection-page-swatch").find(".color-name").text(swatchColorName);
  let gridItem = BtnElement.closest(".collection-product-block");
  let ProductJson = JSON.parse(BtnElement.querySelector(".product-json").innerHTML);
  const getPadding = (aspectRatio)=>{
    let padding = 1;
    return ((padding / aspectRatio) * 100);
  };
  console.log(ProductJson);
  let priceElement = ""
  if(window.theme.custom && window.theme.custom.discountCollectionPercentage && ProductJson.tags.includes(`discount_${window.theme.custom.discountCollectionPercentage}`)){
      if(window.theme.custom.discountCollectionPrice == ProductJson.compare_at_price){
        priceElement = `<span class="theme-money">${window.theme.custom.discountCollectionPrice}</span>`
      }else{
          if(ProductJson.compare_at_price != null){
                    priceElement = `
              <span class="theme-money">${window.theme.custom.discountCollectionPrice}</span>
              <span class="was-price theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>
              `;
          }else{
          	priceElement = `<span class="theme-money">${window.theme.custom.discountCollectionPrice}</span>`
          }
      }
  }
  else{
        if(ProductJson.price == ProductJson.compare_at_price){
        priceElement = `<span class="theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>`
      }else{
        if(ProductJson.compare_at_price != null){
          priceElement = `
    <span class="theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>
    <span class="was-price theme-money">${theme.Shopify.formatMoney(ProductJson.compare_at_price, window.theme.money_format).replaceAll(".00", "")}</span>
    `;
        }else{
        	priceElement = `<span class="theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>`
        }
        
        
      	
      }
  }
  
  $(event.target).parents(".product-block__inner").find(".price").html(priceElement);
 

  /*-- Load Media --*/
  if(ProductJson.media.length){
    let firstImageHtml =`<div class="rimage-outer-wrapper" style="max-width: ${ProductJson.media[0].width} px">
<div class="rimage-wrapper " style="padding-top:${getPadding(ProductJson.media[0].aspect_ratio)}%">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt="" 
data-srcset="${ProductJson.media[0].src}_720x.png?v=1626405866 720w, ${ProductJson.media[0].src}_900x.png?v=1626405866 900w, ${ProductJson.media[0].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[0].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[0].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[0].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[0].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${ProductJson.media[0].src}_720x.png?v=1626405866 720w, ${ProductJson.media[0].src}_900x.png?v=1626405866 900w, ${ProductJson.media[0].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[0].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[0].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[0].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[0].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${ProductJson.media[0].src}_1024x1024.png?v=1626405866" alt="${ProductJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;
    console.log(gridItem)
    gridItem.querySelector(".image__first").innerHTML = "";
    gridItem.querySelector(".image__first").innerHTML = firstImageHtml;

    if(ProductJson.media[1]){
      let secondImageHtml =`<div class="rimage-outer-wrapper" style="max-width: ${ProductJson.media[1].width} px">
<div class="rimage-wrapper " style="${getPadding(ProductJson.media[1].aspect_ratio)}">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt="" 
data-srcset="${ProductJson.media[1].src}_720x.png?v=1626405866 720w, ${ProductJson.media[1].src}_900x.png?v=1626405866 900w, ${ProductJson.media[1].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[1].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[1].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[1].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[1].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${ProductJson.media[1].src}_720x.png?v=1626405866 720w, ${ProductJson.media[1].src}_900x.png?v=1626405866 900w, ${ProductJson.media[1].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[1].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[1].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[1].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[1].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${ProductJson.media[1].src}_1024x1024.png?v=1626405866" alt="${ProductJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;
      gridItem.querySelector(".image__second").innerHTML = "";
      gridItem.querySelector(".image__second").innerHTML= secondImageHtml;
    }
  }

  /*-- Load Sizes --*/
  gridItem.querySelector(".size-wrapper").innerHTML = "";
  gridItem.querySelector(".size-wrapper").innerHTML += `<div class="quick-form__variant-message">TALLAS DISPONIBLES:</div>`;
  let sizeHTML = ""
  for(let variant of ProductJson.variants){
    //     console.log(variant);
    let variantId = variant.id;
    let variantAvailable = variant.available;
    let variantTitle = variant.title;
    let showSoldOut = "";
    !variantAvailable ? showSoldOut = "sold-out" : false;
    let variantUrl = `${ProductJson.url}?variant=${variantId}`;
    // 	console.log(variantUrl);
    sizeHTML += `<div class="sizes ${showSoldOut}"><button onclick='window.location.href="${variantUrl}";' class="size" data-variant-id="${variantId}" data-variant-title="${variant.title}">${variant.title}</button></div>`;
  }
  gridItem.querySelector(".size-wrapper").innerHTML += sizeHTML;

  $(BtnElement).parents(".product-block__inner").find("a").attr("href", ProductJson.url);
  //   console.log(ProductJson);
}

function sizeSelector(event){
  let sizeBtn = event.target;
  //console.log(sizeBtn);
  let variantId = sizeBtn.getAttribute("data-variant-id");
  let variantQty = 1;
  //console.log(variantId, variantQty);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: variantQty
    },
    dataType: 'json',
    success: function(response) {
      var offset = 25;
      var nav = theme.Nav();
      nav.bar.getPositionSetting() !== "inline" ? offset = nav.bar.height() : false;
      console.log(offset);
      
      var product = response;
      var noCheckoutButton = true; //Preload the thumbnail image
      var thumbUrl = theme.Shopify.formatImage(response.image, '300x');
      var img = new Image();
      img.src = thumbUrl;
      var variantHtml;
      if (product.options_with_values && product.options_with_values.length) {
        variantHtml = '';
        for (var _i = 0; _i < product.options_with_values.length; _i++) {
          var option = product.options_with_values[_i];
          if (option.name !== "Title" && option.value !== "Default Title") {
            variantHtml += "<p class=\"cart-product__content__meta\">".concat(option.name, ": ").concat(option.value, "</p>");
          }
        }
      }      
      showThemeModal(['<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">', "<div class=\"inner\" style=\"top:".concat(offset, "px\">"), '<a href="#" data-modal-close class="modal-close">&times;</a>', '<h4 id="added-to-cart-title">' + theme.icons.tick + theme.strings.productAddedToCart + '</h4>', '<div class="cart-product">', "<div class=\"cart-product__image\"><img src=\"".concat(thumbUrl, "\" alt=\"").concat(response.featured_image.alt, "\"/></div>"), '<div class="cart-product__content">' + '<p class="cart-product__content__title">', response.product_title, '</p>' + "".concat(variantHtml ? variantHtml : '') + '</div>', '</div>' , "<p class=\"links ".concat(noCheckoutButton ? 'links--no-checkout' : '', "\">"), '<a href="' + theme.routes.cart_url + "\" class=\"button ".concat(noCheckoutButton ? '' : 'alt', "\">") + theme.strings.viewCart + '</a>', '<a href="' + theme.routes.checkout + '" class="button button--checkout" [data-cc-checkout-button]>' + theme.strings.popupCheckout + '</a> ', '</p>', '</div>', '</div>'].join(''), null, null, false, true);
    },
    error: function(error) {
      console.log(error.responseText);
    }
  });


}

document.addEventListener('click',function(e){
  console.log(e.target)
  if(e.target && e.target.classList.contains('size-quick-add-to-cart')){
    sizeSelector(e);
  }
  else if(e.target && e.target.classList.contains("swatch-btn-image")){    
    swatchSelector(e);
  }
  else{
    return false;
  }
});

function sizeEventHandler(event){
  
  
  //   $(event.currentTarget).parents(".clickyboxes.options-talla").find("li").each(function(){
  //   	$(this).find("a").removeClass("active");
  //   });

  //   $(event.currentTarget).find("a").addClass("active");
  
  //   if(event.currentTarget.classList.contains("unavailable") || event.currentTarget.classList.contains("variant-sold-out")){

  //     //     if(document.querySelector(".klaviyo-bis-trigger")) document.querySelector(".klaviyo-bis-trigger").style.display = "inline-block";
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").innerText = window.theme.strings.buttonNoStock;
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").setAttribute("disabled", "disabled");
  //     document.querySelector(".fab-add-to-cart").innerText = window.theme.strings.buttonNoStock;
  //     document.querySelector(".fab-add-to-cart").setAttribute("disabled", "disabled");
  //   }else{
  //     //     if(document.querySelector(".klaviyo-bis-trigger"))document.querySelector(".klaviyo-bis-trigger").style.display = "none";
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").innerText = window.theme.strings.buttonAddToCart;
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").removeAttribute("disabled");
  //     document.querySelector(".fab-add-to-cart").innerText = window.theme.strings.buttonAddToCart;
  //     document.querySelector(".fab-add-to-cart").removeAttribute("disabled");    
  //   }
}
window.onload = function() {
  // const clickboxSize = document.querySelector(".clickyboxes.options-talla")?.querySelectorAll("li:not(.cc-hover-line)");
  // clickboxSize?.forEach(function(sizeElement) {
  //   if (!(window.location.href).includes("?variant=")) {
  //     sizeElement.querySelector("a").classList.remove("active");
  //   }

  //   sizeElement.addEventListener("click", sizeEventHandler.bind(this));
  // });
  var vid = document.getElementById("player");
  var playvideo = document.getElementById("play_video");
  if(playvideo && vid){
    vid.onclick = function() {
      vid.addEventListener('playing', function() {
        playvideo.style.display = "none";
      })
      vid.addEventListener('pause', function() {
        playvideo.style.display = "block";
      })
      vid[vid.paused ? 'play' : 'pause']();
    }
    playvideo.onclick = function() {
      vid.play();
      playvideo.style.display = "none";
    }
    vid.onended = function() {
      playvideo.style.display = "block";
    };
  }
  
}
// (function(){
//   document.querySelector(".plyr__controls .swiper-no-swiping").style.display = "none !important"
// })();